import { useBroadcastChannel } from '@vueuse/core'

/**
 * Message types carried on the 'Auth' broadcast channel.
 * @readonly
 * @enum {string}
 */
export const AuthChannelMessage = {
	Logout: 'logout',
	Login: 'login'
}

/**
 * Single shared 'Auth' BroadcastChannel instance for the whole tab.
 *
 * A BroadcastChannel never delivers a message back to the context that posted it, which is what lets
 * the tab performing a logout skip its own "you were signed out elsewhere" handling without a
 * suppression flag. That only holds while every caller shares ONE instance - two separate
 * useBroadcastChannel({ name: 'Auth' }) instances in the same tab DO deliver to each other. Import
 * this module rather than opening the channel again.
 * @type {{post: function, data: import('vue').Ref, isSupported: import('vue').Ref<boolean>, error: import('vue').Ref, close: function}}
 */
export const authChannel = useBroadcastChannel({ name: 'Auth' })
